import React, { useContext } from "react";

import classnames from "classnames";

import { useTranslation } from "components/i18n/source";
import { PropertyListingContext } from "components/store/source";
import { Section } from "components/ui/source";

import { IconMap, IconTrain, IconParkingSign } from "icons";

import IconText from "../IconText";

import styles from "./InfoTilesGrid.module.scss";

interface InfoTilesGridProps {
  className?: string;
}

export default function InfoTilesGrid({ className }: InfoTilesGridProps) {
  const { t } = useTranslation();
  const { listing } = useContext(PropertyListingContext);
  const prefix = "listing:neighborhood";
  const infoList = [
    {
      Icon: IconMap,
      title: t(`${prefix}.address`),
      description: listing?.buildingAddress,
    },
    {
      Icon: IconTrain,
      title: t(`${prefix}.publicTransit`),
      description: listing?.publicTransportationInfo,
    },
    {
      Icon: IconMap,
      title: t(`${prefix}.downtown`),
      description: listing?.downtownDrivingInfo,
    },
    {
      Icon: IconParkingSign,
      title: t(`${prefix}.parking`),
      description: listing?.parkingInfo,
    },
  ];

  // Do not show info tile if description data is unavailable
  const infoTiles = infoList
    .filter(info => info.description)
    .map(info => <IconText key={info.title} {...info} />);

  // Return null if no data
  if (infoTiles.length == 0) return null;

  return (
    <Section className={classnames(styles.container, className)}>
      {infoTiles}
    </Section>
  );
}
